import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { FETCH_CLEARANCE, fetchClearanceSuccess, fetchClearanceFailure } from './actions';
import { fetchClearance } from './api';

export function* fetchClearanceSaga(action) {
    try {
        const { status, data } = yield call(fetchClearance, action.value);

        switch (status) {
            case 200:
            case 201:
            case 202:
                yield put(fetchClearanceSuccess(data));
                break;
            default:
                yield put(fetchClearanceFailure(data));
        }
    } catch (e) {
        yield put(fetchClearanceFailure(e));
    }
}

export function* watchForFetchClearance() {
    yield takeEvery(FETCH_CLEARANCE, fetchClearanceSaga);
}

export default function* root() {
    yield all([fork(watchForFetchClearance)]);
}
